import Message from '@/utils/message.js';

export default function install(Vue, connection, { store, userInfo }) {
  const socket = new WebSocket(connection);

  const sendPing = () => {
    window.setTimeout(() => {
      socket.send('ping');
      sendPing();
    }, 28000);
  };

  Vue.prototype.$socket = socket;
  socket.addEventListener('open', () => {
    store.commit('socketStatus', true);
    socket.send(`teacher,${userInfo.userid}`);
    sendPing();
    try {
      Vue.notification.requestPermission().then((status) => {
        socket.send(JSON.stringify({
          name: 'notifyPermissionStatus',
          userId: userInfo.userid,
          site: Vue.prototype.$siteName,
          status,
        }));
      });
      // eslint-disable-next-line
    } catch (e) {
    }
  });

  socket.addEventListener('close', () => {
    store.commit('socketStatus', false);
  });

  socket.addEventListener('message', (event) => {
    const message = new Message(store, Vue.prototype.$notification);
    message.parse(event.data);
  });
}
